// extracted by mini-css-extract-plugin
export default {"NoPage":"NoPage_NoPage__hgTQx","message":"NoPage_message__yX4e5"};